import { render, staticRenderFns } from "./BaseStep.vue?vue&type=template&id=48678932&scoped=true&"
import script from "./BaseStep.vue?vue&type=script&lang=js&"
export * from "./BaseStep.vue?vue&type=script&lang=js&"
import style0 from "./BaseStep.vue?vue&type=style&index=0&id=48678932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48678932",
  null
  
)

export default component.exports